import HorizontalScroll from '@cartwhl/ui/atoms/HorizontalScroll';
import Text from '@cartwhl/ui/base/Text';

export type LogoItem = {
  name: string;
  icon?: React.ReactNode;
  width?: string;
};

export default function LogoCarousel({
  label,
  logos,
  className,
  listClassName,
}: {
  label: string;
  logos: LogoItem[];
  className?: string;
  listClassName?: string;
}) {
  return (
    <div className={className}>
      <div className="container mb-4 lg:mb-8">
        <Text
          lg:variant="web/body/medium/24"
          variant="web/body/medium/md"
          className="text-tertiary"
        >
          {label}
        </Text>
      </div>
      <HorizontalScroll>
        <div className={`flex gap-9 lg:gap-16 ${listClassName}`}>
          {logos.map((logo) => (
            <div
              key={logo.name}
              className={`flex h-12 flex-none items-center justify-center rounded-2xl lg:h-20 [&>svg]:h-full [&>svg]:w-full [&>svg]:shrink-0 ${logo.width ?? 'w-[131px] lg:w-[243px]'}`}
              aria-label={logo.name}
              role="img"
            >
              {logo.icon}
            </div>
          ))}
        </div>
      </HorizontalScroll>
    </div>
  );
}
